import { connect } from 'react-redux';
import BannerList from './BannerList';
import { closeWriteOffMessage } from 'modules/App/redux/user/actions';
import { closeBanner, startRequest as getBanners } from 'modules/App/redux/bannerList/actions';
import { closeBanner as closeBannerRequest } from 'modules/App/services/API';
import { selectBanners, selectUser } from 'modules/App/utils/selectors';

const mapStateToProps = (state) => ({
  user: selectUser(state),
  bannerList: selectBanners(state),
});

const mapDispatchToProps = {
  closeWriteOffMessage,
  closeBanner,
  closeBannerRequest,
  getBanners,
};

export default connect(mapStateToProps, mapDispatchToProps)(BannerList);
